import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/** Calls the API to retrieve joint-use functionalizations for a load request. */
export const executeLoad = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.load.request.observe().pipe(
      rxjs.switchMap(action =>
        plugin.api.get(action.data.context, action.data.params).pipe(
          rxjs.takeUntil(
            rxjs.merge(
              plugin.collection.feature.actions.changeContext.observe(),
              feature.actions.loadForCurrentEntity.request.observe(),
              feature.actions.releaseCurrentEntityTarget.request.observe(),
              feature.actions.setCurrentEntityTarget.request.observe(),
            ),
          ),
          rxjs.map(response =>
            feature.actions.load.success
              .from(action)
              .create({ request: action.data, response }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.load.error
                .from(action)
                .create({ error, request: action.data }),
            ),
          ),
        ),
      ),
    ),
)
